export default "__VITE_ASSET__FI7R7U$V__"